import React from 'react';
import { IProps } from './types';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setExplainModalVisibleAction } from 'redux/actions/modal.action';
import { RootReducersState } from 'redux/reducers';
import Modal from 'components/Modal';
import commonService from 'utils/commonService';

const ExplainModal: React.FC<IProps> = (props) => {
  const thead = props.data ? props.data[0] : [];
  const tbody = props.data ? props.data.slice(1) : [];

  const handleClose = () => {
    props.setExplainModalVisible(false);
  };

  return (
    <>
      {props.modal.explainModalVisible && (
        <div className="explain-modal">
          <Modal
            visible={props.modal.explainModalVisible}
            // title={props.title ?? '如何填寫'}
            confirmButton={false}
            onCancel={handleClose}
          >
            <h2 className="explain-modal__header">{props.tableTitle}</h2>
            {props.data && props.data.length > 0 &&
              <table>
                <thead>
                  <tr>
                    {thead.map((item, index) => {
                      if (item.includes('<br>')) {
                        const items = item.split('<br>');
                        return (
                          <th className="diagonal-line" key={index}>
                            {items.map((item, index) => <p key={index} className="diagonal-item">{commonService.htmlParser(item)}</p>)}
                          </th>
                        );
                      } else {
                        return <th key={index}><p>{commonService.htmlParser(item)}</p></th>;
                      }
                    })}
                  </tr>
                </thead>
                <tbody>
                  {tbody.map((items, index) => (
                    <tr key={index}>
                      {items.map((item, index) => {
                        if (item.includes('<br>')) {
                          const items = item.split('<br>');
                          return (
                            <td className="two-items" key={index}>
                              {items.map((item, index) => (
                                <div key={index}>
                                  <p>{commonService.htmlParser(item)}</p>
                                </div>
                              ))}
                            </td>
                          );
                        } else {
                          return <td key={index}><p>{commonService.htmlParser(item)}</p></td>;
                        }
                      })}
                    </tr>))}
                </tbody>
              </table>}
          </Modal>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setExplainModalVisible: (visible: boolean) => dispatch(setExplainModalVisibleAction(visible))
});

export default connect(mapStateToProps, mapDispatchToProps)(ExplainModal);
